
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7469ff71008933f14e31980a575071ccen from './en.yaml'
            i18n.addResourceBundle('en', '7469ff71008933f14e31980a575071cc', flattenObject(ns7469ff71008933f14e31980a575071ccen), true, true);
        
        export default '7469ff71008933f14e31980a575071cc';
    